export default __webpack_public_path__ + "7a57c1636da6747b6d172d9034802cce.svg";